import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
    usersTable: {
        marginTop: '10px',
    },
}));
